import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [bundle, setBundle] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await api.get("/content-bundle", {
          headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
        });
        if (!cancelled) setBundle(res.data || {});
      } catch (err) {
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ContentContext.Provider value={{ bundle, loading, error }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = (sectionId) => {
  const ctx = useContext(ContentContext);
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(!ctx);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (ctx) return undefined;
    let cancelled = false;
    const fetchContent = async () => {
      try {
        const res = await api.get(`/content/${sectionId}`, {
          headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
        });
        if (!cancelled) setContent(res.data.content);
      } catch (err) {
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchContent();
    return () => {
      cancelled = true;
    };
  }, [sectionId, ctx]);

  if (ctx) {
    return {
      content: ctx.bundle?.[sectionId] || null,
      loading: ctx.loading,
      error: ctx.error,
    };
  }

  return { content, loading, error };
};
